import React from "react";

//*MUI
import { Box, Popover, Tooltip } from "@mui/material";

//*files
import cssClasses from "./FloorComponents.module.css";
import ClockIcon from "../../Components/Icons/ClockIcon";
import { Typography } from "@material-ui/core";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import LeadStatusChip from "../LeadStatusChip";
import Dot from "../../Components/Icons/Dot";

function BlockDiv({
  style,
  time,
  Size,
  flatNo,
  Price,
  clicked,
  CheckBox = false,
  changeUnit,
  isSelected,
  margin,
  paired = false,
  pairedInfo = "",
  Name,
  NameTitle,
  Sale,
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (e) => {
    e.stopPropagation();
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  return (
    <Box
      className={cssClasses.flexCol}
      style={{ backgroundColor: style.backgroundColor }}
      onClick={clicked}
    >
      {CheckBox === true && (
        <Box
          marginLeft={"auto"}
          padding={"0.3rem 1rem 0 0"}
          display={"flex"}
          flexDirection={"row"}
        >
          <Box
            style={{ color: style.color }}
            className={cssClasses.DetailsTitle}
          >
            {time}
          </Box>
          <label className={cssClasses.container}>
            <input
              className={cssClasses.checkbox}
              type="checkbox"
              name=""
              id=""
              onChange={(e) => {
                e.stopPropagation();
                changeUnit();
              }}
              onClick={(e) => e.stopPropagation()}
              checked={isSelected}
            />
            <span
              onClick={(e) => e.stopPropagation()}
              className={cssClasses.checkmark}
            ></span>
          </label>
        </Box>
      )}
      <Box mt={margin}>
        <Box style={{ color: style.color }} className={cssClasses.DetailsTitle}>
          {Size}
        </Box>
        <Box style={{ color: style.color }} className={cssClasses.DetailsTitle}>
          {flatNo}
        </Box>
        <Box style={{ color: style.color }} className={cssClasses.DetailsTitle}>
          {Price}
        </Box>

        <Tooltip title={<h1>{NameTitle}</h1>}>
          <Box
            style={{ color: style.color }}
            className={cssClasses.DetailsTitle1}
          >
            {Name}
          </Box>
        </Tooltip>
      </Box>
      {paired && (
        <Box style={{ color: style.color }} className={cssClasses.paired}>
          <Box className={cssClasses.DetailsTitle} mr={0.2}>
            Paired
          </Box>
          <Box mt={0.2}>
            <InfoOutlinedIcon
              onClick={handleClick}
              style={{
                width: "2rem",
                height: "2rem",
                color: "#344054",
                cursor: "pointer",
              }}
            ></InfoOutlinedIcon>
            <Popover
              id={id}
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
            >
              <Typography
                style={{
                  fontSize: "1.4rem",
                  fontFamily: "Inter-Medium",
                  padding: "1rem",
                }}
                sx={{ p: 2 }}
              >
                {pairedInfo}
              </Typography>
            </Popover>
          </Box>
        </Box>
      )}
      {Sale && (
        <Box display={"flex"} justifyContent={"center"}>
          <LeadStatusChip
            style={{
              color: "#B42318",
              backgroundColor: "#FEE4E2",
            }}
            label={"Not for Sale"}
            icon={<Dot width={"0.6rem"} height={"0.6rem"} />}
          />
        </Box>
      )}
    </Box>
  );
}

function AllotmentDiv({ style, content, Quantity }) {
  return (
    <Box
      style={{ backgroundColor: style.backgroundColor }}
      className={cssClasses.AllotmentTitle}
    >
      {content} : {Quantity}
    </Box>
  );
}

export { BlockDiv, AllotmentDiv };
